import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Grid,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  Switch,
  Tooltip,
  withStyles
} from "@material-ui/core";
import React, { useState, useEffect, MouseEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import useStyles from "./DashBoard.css";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import CheckIcon from "@material-ui/icons/Check";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import PeopleOutlinedIcon from "@material-ui/icons/PeopleOutlined";
import CheckCircleOutlineOutlinedIcon from "@material-ui/icons/CheckCircleOutlineOutlined";
import BlockOutlinedIcon from "@material-ui/icons/BlockOutlined";
import FeedbackIcon from "@material-ui/icons/Feedback";
import FeedbackOutlinedIcon from "@material-ui/icons/FeedbackOutlined";
import CallIcon from "@material-ui/icons/Call";
import { VendorListItem } from "../../../models/VendorList";
import { ApprovalPopupModel } from "../../../models/ApprovalPopupModel";
import { RequestService } from "../../../services/RequestService";
import { VendorBlockingService } from "../../../services/VendorBlockingService";
import { ResponseObject } from "../../../models/ResponseObject";
import AllActions from "../../../actions";
import translation from "../../../i18n/i18.json";
//import ApprovalPopup from "../../components/ApprovalPopup/ApprovalPopup";
import ApproveDialog from "../../../components/Vendor/Popup/Confirmation/ApproveDialog";
import RejectDialog from "../../../components/Vendor/Popup/Confirmation/RejectDialog";
import { RoleUtil } from "../../../utils/RoleUtil";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
//import PendingActionsIcon from "@material-ui/icons/PendingActions";
import AlbumOutlinedIcon from "@material-ui/icons/AlbumOutlined";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import CancelIcon from "@material-ui/icons/Cancel";

import {
  AppApprovalPoints,
  InforDisplyaDuration,
  NavigationPaths,
  RequestStatus,
  RequestStatusLabel,
  RequestTypes,
  ResponseObjectType,
  VendorForm1Modes,
  VendorRequestViewMode,
} from "../../../constants/AppConstants";
import { ApprovalStatusData } from "../../../models/Approval/ApprovalStatusData";
import { useHistory } from "react-router-dom";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { VendorType } from "../../../models/VendorType";
import { RequestType } from "../../../models/RequestType";
//import { DashboardFilter } from "../../models/DashBoard/DashboardFilter";
import { setConstantValue } from "typescript";
import { SettingsInputAntenna } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import { Util } from "../../../utils/Util";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import AllOutRoundedIcon from "@material-ui/icons/AllOutRounded";
import LockOpenRoundedIcon from "@material-ui/icons/LockOpenRounded";
import { VendorUnBlockingService } from "../../../services/VendorUnBlockingService";
import { RequestStatusModel } from "../../../models/RequestStatusModel";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { DashboardFilter } from "../../../reducers/vendor/VendorDashboradFilterReducer";
import { RootState } from "../../../reducers";
import { VendorMasterData } from "../../../services/VendorMasterData";
import EditIcon from "@material-ui/icons/Edit";
import BlockIcon from "@material-ui/icons/Block";
import ExtensionIcon from "@material-ui/icons/Extension";
import { MasterDataService } from "../../../services/MasterDataService";
import { VendorCategory } from "../../../models/Master/VendorCategory";

export default function DashBoard(props: any) {
  const { nofityRequestNumber, setNofityRequestNumber } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [vendorListItems, setVendorListItems] = useState<VendorListItem[]>([]);
  const [approvalPopupModel, setapprovalPopupModel] =
    useState<ApprovalPopupModel>();

  const [openApprove, setOpenApprove] = useState(false);
  const [dataToApprove, setDataToApprove] = useState<ApprovalStatusData>();
  const [openReject, setOpenReject] = useState(false);
  const [selectedItem, setSelectedItem] = useState<VendorListItem>();

  const [vendorTypes, setVendorTypes] = useState(Array<VendorType>());
  const [vendorCategories, setVendorCategories] = useState(Array<VendorCategory>());
  const [requestTypes, setRequestTypes] = useState(Array<RequestType>());
  //const [requestStatus, setRequestStatus] = useState(Array<RequestStatusModel>());
  const [requestStatus, setRequestStatus] = useState<RequestStatusModel[]>([
    { id: "", name: "None" },
    { id: RequestStatus.Initial, name: RequestStatusLabel.Initial },
    { id: RequestStatus.Pending, name: RequestStatusLabel.Pending },
    { id: RequestStatus.Complete, name: RequestStatusLabel.Complete },
    { id: RequestStatus.Rejected, name: RequestStatusLabel.Rejected },
    { id: RequestStatus.Cancelled, name: RequestStatusLabel.Cancelled },
  ]);

  const rowsPerPage = 10;
  const [rowCount, setRowCount] = React.useState(0);
  const [isTableLoading, setIsTableLoading] = React.useState(false);
  const filterParams: DashboardFilter = useSelector<RootState, DashboardFilter>(
    (state) => state.vendorDashboradFilter
  );

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };
  
  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };

  useEffect(() => {
    if (nofityRequestNumber) {
      //setFilterParams({ ...filterParams!, ["RequestNo"]: nofityRequestNumber });
      dispatch(
        AllActions.dashboardFilterActions.updateVendorFilterData(
          "RequestNo",
          nofityRequestNumber
        )
      );
      setNofityRequestNumber(null);
    }
  }, [nofityRequestNumber]);

  //useEffect(() =>   getVendorList(), [page]);
  useEffect(() => {
    if (isTableLoading) {
      getVendorList();
    }
  }, [isTableLoading]);

  useEffect(() => {
    setIsTableLoading(true);

    VendorDetailService.getVendorTypes(
      function (vendorTypesData: Array<VendorType>) {
        vendorTypesData.splice(0, 0, { code: "", name: "None" });
        setVendorTypes(vendorTypesData);
        //compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        setVendorTypes([]);
        //compeleteRequest(false, translation.profile_pastemp_get_error);
      }
    );

    MasterDataService.getVendorCategories(
      function (vendorCategoryList: Array<VendorCategory>) {
        vendorCategoryList.splice(0, 0, { id: 0, name: "None" });
        setVendorCategories(vendorCategoryList);
      },
      function () {
        setVendorCategories([]);
      }
    );

    VendorMasterData.GetRequestTypes(
      function (requestTypesData: Array<RequestType>) {
        requestTypesData.splice(0, 0, { code: "", name: "None" });
        setRequestTypes(requestTypesData);
        //compeleteRequest(true);
      },
      function (error: Error) {
        console.log(error);
        setRequestTypes([]);
        //compeleteRequest(false, translation.profile_pastemp_get_error);
      }
    );
  }, []);

  const onAproveRequestConfirm = (approvalLevelId: number) => {
    setOpenApprove(false);
    setIsTableLoading(true);
  };

  const onAproveRequestCancel = () => {
    setOpenApprove(false);
  };

  const onApproveClose = () => {
    setOpenApprove(false);
  };

  const onApproveClick = (vendorListItem: VendorListItem) => {
    setDataToApprove({
      requestId: vendorListItem?.requestId!,
      requestComment: vendorListItem.comment,
      companyCountryCode: vendorListItem.companyCountryCode,
      approvalStatusId: 1,
      approvalLevelId: ApprovalPointUtil.getUserPermitedApprovalPoint(vendorListItem.companyCode, vendorListItem.currentApprovalPointIds),
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName: "",
      vcExtendedInputs: {
        purposeCode: vendorListItem.purposeCode,
        accountingClark: ApprovalPointUtil.isSAPCreateOrAmendOrExtend(
          vendorListItem?.currentApprovalPointIds[0]!
        )
          ? vendorListItem?.accountingCleark
          : "",
        accountingClarkEmail: ApprovalPointUtil.isSAPCreateOrAmendOrExtend(
          vendorListItem?.currentApprovalPointIds[0]!
        )
          ? vendorListItem?.accountingEmail
          : "",
          instructionKey: vendorListItem.instructionKey,
        sortKey:vendorListItem.sortKey,
        isIndividualVendor : vendorListItem.isIndividualVendor
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode:vendorListItem?.vendorTypeCode,
      isTemporaryApproval: (vendorListItem?.tempApprovalDays && vendorListItem?.tempApprovalDays > 0) ? true : false,
      temporaryApprovalNoOfDays: (vendorListItem?.tempApprovalDays && vendorListItem?.tempApprovalDays > 0) ? vendorListItem?.tempApprovalDays.toString() : ""
    });
    setSelectedItem(vendorListItem);
    setOpenApprove(true);
  };

  // const removeItemVendorList = (vendorId: number) => {
  //   setVendorListItems(
  //     vendorListItems.filter((row: VendorListItem) => {
  //       return row.requestId !== vendorId;
  //     })
  //   );
  // };

  const updateVendorListApprovalLevelId = (
    requestId: number,
    value: number
  ) => {
    var newList: Array<VendorListItem> = vendorListItems.map(
      (row: VendorListItem) => {
        if (row.requestId === requestId) {
          return { ...row, "currentApprovalPointId": value };
        }
        return row;
      }
    );
    setVendorListItems(newList);
  };

  const onRejectRequestConfirm = (approvalLevelId: number) => {
    //send aprove request
    setOpenReject(false);
    setIsTableLoading(true);
  };

  const onRejectRequestCancel = () => {
    setOpenReject(false);
  };

  const onRejectClose = () => {
    setOpenReject(false);
  };

  const onRejectClick = (vendorListItem: VendorListItem) => {
    setDataToApprove({
      requestId: vendorListItem?.requestId!,
      requestComment: vendorListItem.comment,
      companyCountryCode:"",
      approvalStatusId: 2,
      approvalLevelId: vendorListItem?.currentApprovalPointIds[0],
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName :"",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey:"",
        isIndividualVendor: false
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode:"",
      isTemporaryApproval:false,
      temporaryApprovalNoOfDays:""
    });
    setSelectedItem(vendorListItem);
    setOpenReject(true);
  };

  const navigateToForm1 = (vendorListItem: VendorListItem) => {
    dispatch(AllActions.vendorCreationActions.resetRequestDetails(""));
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.VendorRequest, {
      mode: VendorForm1Modes.VendorInitialCreate,
      requestNumber: vendorListItem.requestNo,
      companyCode: vendorListItem.companyCode,
      poCodes: vendorListItem.poCodes
    });
  };

  const navigateToVendorDetail = (
    vendorId: any,
    requestId: any,
    isForceEdit: boolean,
    detailmode: VendorRequestViewMode,
    requestNo: any
  ) => {
    dispatch(AllActions.vendorCreationActions.resetRequestDetails(""));
    dispatch(AllActions.vendorDetailActions.resetVendorDetails());
    history.push(NavigationPaths.VendorDetail, {
      vendorId: vendorId,
      requestId: requestId,
      isForceEdit: isForceEdit,
      mode: detailmode,
      requestNo: requestNo,
    });
  };
  const isForm1UpdateMode = (vendorListItem: VendorListItem) => {
    return vendorListItem.previousApprovalPointId 
      && (vendorListItem.currentApprovalPointIds[0] == AppApprovalPoints.VCInitial 
          || vendorListItem.currentApprovalPointIds[0] == AppApprovalPoints.VAVendorFill)
      && (vendorListItem.requestTypeId == RequestTypes.VendorCreate 
          || vendorListItem.requestTypeId == RequestTypes.VendorAmend) 
      && (vendorListItem.previousApprovalPointId == AppApprovalPoints.VCHoD
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VCFinnce01
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VCExCo
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VAHoD
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VAExCo
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VAFinnce01
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VCBusinessDirector
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VCSBU_SC_HEAD
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VASBU_SC_HEAD
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VCGSSC_CAT_LEAD
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VcNmrp_CategoryManager
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VaNmrp_CategoryManager
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VcNmrp_ServiceHead
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VaNmrp_ServiceHead
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VcNmrpPillarHead
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VaNmrpPillarHead
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VcProcurementDirector
          || vendorListItem.previousApprovalPointId == AppApprovalPoints.VaProcurementDirector);
  };

  const onNavigateArrowClick = (vendorListItem: VendorListItem) => {
    if (ApprovalPointUtil.isCallOverVerification( vendorListItem.currentApprovalPointIds[0], vendorListItem.requestStatusId ) 
      && ApprovalPointUtil.isUserPermitedApprovalPoint( vendorListItem.companyCode, vendorListItem.currentApprovalPointIds )
    ) {
      navigatetoCallOver(vendorListItem);
    } 
    //if create vendor in initial status and previous approval point is HOD, Exco, SBU Finance
    else if(isForm1UpdateMode(vendorListItem)) {
      navigateToForm1(vendorListItem);
    } else {
      //check record can be edited, if so show confirmtation only if isVendorFillForm2 is true
      let detailmode = VendorRequestViewMode.VendorCreate;
      switch (vendorListItem.requestTypeId) {
        case RequestTypes.VendorCreate:
          detailmode = VendorRequestViewMode.VendorCreate;
          break;
        case RequestTypes.VendorAmend:
          detailmode = VendorRequestViewMode.VendorAmend;
          break;
        case RequestTypes.VendorExtend:
          detailmode = VendorRequestViewMode.VendorExtend;
          break;
        case RequestTypes.VendorBlock:
          detailmode = VendorRequestViewMode.VendorBlock;
          break;
        case RequestTypes.VendorUnBlock:
          detailmode = VendorRequestViewMode.VendorUnBlock;
          break;
        case RequestTypes.VendorIndividualPay:
            detailmode = VendorRequestViewMode.VendorIndividualPay;
            break;
        case RequestTypes.VendorBlockExcemption:
            detailmode = VendorRequestViewMode.VendorBlockExcemption;
            break;
        default:
          detailmode = VendorRequestViewMode.VendorCreate;
      }
      if (vendorListItem.requestStatusId === RequestStatus.Initial && vendorListItem.isVendorFillForm2 ) {
        dispatch(
          AllActions.alertDialogActions.openAlertDialog(
            translation.dashboard_navdetail_con_title,
            translation.dashboard_navdetail_con_msg,
            translation.dashboard_navdetail_con_yesbtn,
            function () {
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
              navigateToVendorDetail(
                vendorListItem.vendorId,
                vendorListItem.requestId,
                true,
                detailmode,
                vendorListItem.requestNo
              );
            },
            translation.dashboard_navdetail_con_nobtn,
            function () {
              dispatch(AllActions.alertDialogActions.closeAlertDialog());
              navigateToVendorDetail(
                vendorListItem.vendorId,
                vendorListItem.requestId,
                false,
                detailmode,
                vendorListItem.requestNo
              );
            }
          )
        );
      } else {
        navigateToVendorDetail(
          vendorListItem.vendorId,
          vendorListItem.requestId,
          false,
          detailmode,
          vendorListItem.requestNo
        );
      }
    }
  };

  const handleChange = (input: string) => (e: any) => {
    let val: any = e.target.value;
    if (e.target.type === "checkbox") {
      dispatch(AllActions.dashboardFilterActions.updateVendorFilterData(input, e.target.checked));
    } else if (input === "VendorCategoryId") {
      dispatch(AllActions.dashboardFilterActions.updateVendorFilterData(input, parseInt(val) || -1 ));
    } else if (input === "RequestType") {
      dispatch(AllActions.dashboardFilterActions.updateVendorFilterData(input, parseInt(val) ));
    } else if (input === "statusId") {
      dispatch(AllActions.dashboardFilterActions.updateVendorFilterData(input, val));
    } else {
      dispatch(AllActions.dashboardFilterActions.updateVendorFilterData(input, val));
    }
  };

  const getVendorList = () => {
    prepareForRequest();
    RequestService.GetVendorList(
      {
        //pageNo: page + 1,
        pageNo: filterParams!.pageNo,
        PageSize: filterParams!.PageSize,
        RequestDate: filterParams!.RequestDate,
        RequestNo: filterParams!.RequestNo,
        RequestType: filterParams!.RequestType,
        VendorType: filterParams!.VendorType,
        VendorCategoryId: filterParams!.VendorCategoryId,
        IsUrgent: filterParams!.IsUrgent,
        sAPVendorNo: filterParams!.sAPVendorNo,
        vendorName: filterParams!.vendorName,
        statusId: filterParams!.statusId === "" ? null : filterParams!.statusId,
      },
      //filterParams!,page
      (result: ResponseObject) => {
        if (result) {
          if (result.resposeObjectType === 1) {
            compeleteRequest(true);
             setVendorListItems(result.result.vendorListItem);
            setRowCount(result.result.rowCount);
            // setVendorListItems(result.result.vendorListItem.map((item:VendorListItem)=>{
            //     if(item.requestStatusId === 2){
            //       item.rejectReason = "sss";
            //         return item;
            //     }
            //     return item;
            // }));
          } else {
            compeleteRequest(
              false,
              translation.dashboard_load_vendor_list_no_uer_mapped_company_msg
            );
          }
        } else {
          compeleteRequest(false, translation.dashboard_load_vendor_list_error);
        }
        setIsTableLoading(false);
      },
      (error) => {
        compeleteRequest(false, translation.dashboard_load_vendor_list_error);
        setIsTableLoading(false);
      }
    );
  };

  const handleFilter = (e: any) => {
    //setFilterParams({ ...filterParams, pageNo: 1 });
    dispatch(
      AllActions.dashboardFilterActions.updateVendorFilterData("pageNo", 1)
    );
    //setPage(0);
    setIsTableLoading(true);
    //getVendorList();
  };

  const handleFilterClear = (e: any) => {
    dispatch(AllActions.dashboardFilterActions.resetVendorFilter());
    // dispatch(
    //   AllActions.dashboardFilterActions.updateVendorFilterData("pageNo", 1)
    // );
    setIsTableLoading(true);
  };

  const handleChangePage = (event: any, newPage: number) => {
    //setFilterParams({ ...filterParams, pageNo: newPage + 1 });
    dispatch(
      AllActions.dashboardFilterActions.updateVendorFilterData(
        "pageNo",
        newPage + 1
      )
    );
    //setPage(newPage);
    setIsTableLoading(true);
  };

  const navigatetoCallOver = (vendorListItem: VendorListItem) => {
    history.push(NavigationPaths.CallOverVerification, {
      requestId: vendorListItem.requestId,
    });
  };

  const getStatusCls = (requestId: number) => {
    switch (requestId) {
      case RequestStatus.Pending:
        return classes.pendingState;
      case RequestStatus.Initial:
        return classes.initialState;
      case RequestStatus.InitialSubmit:
        return classes.initialState;
      case RequestStatus.Complete:
        return classes.activeState;
      case RequestStatus.Rejected:
        return classes.rejectedState;
      case RequestStatus.Cancelled:
        return classes.cancelledState;
      default:
        return classes.pendingState;
    }
  };

  const getDisplayPO = (row: VendorListItem) => {
    if (row.poCodes && row.poCodes.length > 0) {
      let postring = row.poCodes.join(",");
      return postring;
    }
    return "";
  };

  const LightTooltip = withStyles(theme => ({
    tooltip: {
      boxShadow: theme.shadows[1],
      fontSize: 12,
      letterSpacing: 1
    }
  }))(Tooltip);

  const cancelRequest = (vendorListItem: VendorListItem) => {
    prepareForRequest();
    let cancelData: ApprovalStatusData = {
      requestId: vendorListItem?.requestId!,
      requestComment: vendorListItem.comment,
      companyCountryCode: "",
      approvalStatusId: RequestStatus.Cancelled,
      approvalLevelId: vendorListItem?.currentApprovalPointIds[0],
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName: "",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey:"",
        isIndividualVendor: false
      },
      verifierDesignation: "",
      checkListItems: [],
      vendorTypeCode:"",
      isTemporaryApproval:false,
      temporaryApprovalNoOfDays:""
    };
    RequestService.SetApprovalStatus(
      cancelData,
      function (approvalRespone: ResponseObject) {
        if (
          approvalRespone &&
          (approvalRespone.resposeObjectType === ResponseObjectType.SAPError ||
            approvalRespone.resposeObjectType === ResponseObjectType.Error)
        ) {
          compeleteRequest(false, approvalRespone.message);
        } else if (
          approvalRespone &&
          approvalRespone.resposeObjectType === ResponseObjectType.SAPSuccess
        ) {
          compeleteRequest(
            true,
            translation.dashboard_vendor_request_cancel_suc
          );
          setIsTableLoading(true);
        } else {
          compeleteRequest(
            true,
            translation.dashboard_vendor_request_cancel_suc
          );
          setIsTableLoading(true);
        }
      },
      function (error: Error) {
        console.log(error);
        compeleteRequest(
          false,
          translation.dashboard_vendor_request_cancel_err
        );
      }
    );
  };

  const handleCancelRequest = (vendorListItem: VendorListItem) => {
    dispatch(
      AllActions.alertDialogActions.openAlertDialog(
        translation.dashboard_cancelreq_con_title,
        translation.dashboard_cancelreq_con_msg,
        translation.dashboard_cancelreq_con_yesbtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
          cancelRequest(vendorListItem);
        },
        translation.dashboard_cancelreq_con_nobtn,
        function () {
          dispatch(AllActions.alertDialogActions.closeAlertDialog());
        }
      )
    );
  };

   return (
    <div>
      {/*<Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>*/}
        {/* Status Lable area START */}
        {/* <Grid container spacing={2} item xs={12} sm={12} md={12} lg={4}>
          <div className={classes.statusBlockWrapper}>
            <div className={classes.statusBlock}>
              <span className={classes.allStatus}>
                <span className={classes.statusLbl}>All Status</span>
                <span className={classes.statusCount}>100</span>
              </span>
            </div>
            <div className={classes.statusBlock}>
              <span className={classes.pendingStatus}>
                <span className={classes.statusLbl} style={{ width: "40px" }}>
                  Pending
                </span>
                <span className={classes.statusCount}>100</span>
              </span>
            </div>
            <div className={classes.statusBlock}>
              <span className={classes.blockedStatus}>
                <span className={classes.statusLbl} style={{ width: "40px" }}>
                  Blocked
                </span>
                <span className={classes.statusCount}>100</span>
              </span>
            </div>
            <div className={classes.statusBlock}>
              <span className={classes.activeStatus} style={{ width: "110px" }}>
                <span
                  className={classes.statusLbl}
                  style={{ fontSize: "8px", width: "90px" }}
                >
                  Activate Vendors
                </span>
                <span className={classes.statusCount}>100</span>
              </span>
            </div>
          </div>
        </Grid> */}
        {/* Status Lable area END */}

        {/* Progress area START */}
        {/* <Grid container spacing={2} item xs={12} sm={12} md={12} lg={8}>
          <div className={classes.progressWrapper}>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGray}>
                <span className={classes.creatVendorIcon}>
                  <PeopleOutlinedIcon></PeopleOutlinedIcon>
                </span>
              </span>
              <span className={classes.progreslabel}>Create Vendor</span>
              <span className={classes.progressArrowRight}></span>
            </div>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGray}>
                <span className={classes.cercleGrayTxt}>1</span>
              </span>
              <span className={classes.progreslabel}>HOD, EXCO Approval</span>
              <span className={classes.progressArrowRight}></span>
            </div>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGray}>
                <span className={classes.cercleGrayTxt}>2</span>
              </span>
              <span className={classes.progreslabel}>Vendor</span>
              <span className={classes.progressArrowRight}></span>
            </div>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGray}>
                <span className={classes.cercleGrayTxt}>3</span>
              </span>
              <span className={classes.progreslabel}>Validation</span>
              <span className={classes.progressArrowRight}></span>
            </div>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGray}>
                <span className={classes.cercleGrayTxt}>4</span>
              </span>
              <span className={classes.progreslabel}>Finance to Approve</span>
              <span className={classes.progressArrowRight}></span>
            </div>
            <div className={classes.progressBlock}>
              <span className={classes.cercleGrayActive}>
                <CheckIcon></CheckIcon>
              </span>
              <span className={classes.progreslabel}>Active Vendor</span>
            </div>
          </div>
        </Grid> */}
        {/* Progress area END */}
       {/* </Grid> */}

      {/* Filter area START */}
      <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
        <Grid
          container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.filterheader}
        >
          Filter
        </Grid>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          <div className={classes.filterWrapper}>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_request_date}
              </label>
              <div className={classes.inputWrapper}>
                <TextField
                  variant="outlined"
                  type="date"
                  value={filterParams.RequestDate}
                  onChange={handleChange("RequestDate")}
                ></TextField>
                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Date picker inline"
                value={selectedRequetDate}
                onChange={handleRequestDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              </MuiPickersUtilsProvider> */}
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_request_num}
              </label>
              <div className={classes.inputWrapper}>
                <TextField
                  variant="outlined"
                  value={filterParams.RequestNo}
                  onChange={handleChange("RequestNo")}
                ></TextField>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_request_type}
              </label>
              <div className={classes.inputWrapper}>
                <Select
                  variant="outlined"
                  onChange={handleChange("RequestType")}
                  value={filterParams.RequestType}
                  //error={getErrorState("VendorType")}
                >
                  {requestTypes.map((obj, index) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_request_status}
              </label>
              <div className={classes.inputWrapper}>
                <Select
                  value={filterParams.statusId}
                  variant="outlined"
                  onChange={handleChange("statusId")}
                >
                  {requestStatus.map((obj, index) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                  {/* {Object.values(RequestStatusLabel).map((value, index) => (
                    <MenuItem
                      key={Util.getEnumKeyByEnumValue(
                        RequestStatusLabel,
                        value
                      )}
                      value={value}
                    >
                      {value}
                    </MenuItem>
                  ))} */}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_vendor_name}
              </label>
              <div className={classes.inputWrapper}>
                <TextField
                  variant="outlined"
                  value={filterParams.vendorName}
                  onChange={handleChange("vendorName")}
                ></TextField>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_vendor_num}
              </label>
              <div className={classes.inputWrapper}>
                <TextField
                  variant="outlined"
                  value={filterParams.sAPVendorNo}
                  onChange={handleChange("sAPVendorNo")}
                ></TextField>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_vendor_category}
              </label>
              <div className={classes.inputWrapper}>
                {" "}
                <Select
                  variant="outlined"
                  onChange={handleChange("VendorCategoryId")}
                  value={filterParams.VendorCategoryId}
                  //error={getErrorState("VendorType")}
                >
                  {vendorCategories.map((obj, index) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_vendor_type}
              </label>
              <div className={classes.inputWrapper}>
                {" "}
                <Select
                  variant="outlined"
                  onChange={handleChange("VendorType")}
                  value={filterParams.VendorType}
                  //error={getErrorState("VendorType")}
                >
                  {vendorTypes.map((obj, index) => (
                    <MenuItem key={obj.code} value={obj.code}>
                      {obj.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <label className={classes.filterLbl}>
                {translation.dashboard_filternm_isurgent}
              </label>
              {/* <Checkbox value={filterParams!.IsUrgent}></Checkbox> */}
              <div className={classes.inputWrapper}>
                <Switch
                  checked={filterParams!.IsUrgent}
                  onChange={handleChange("IsUrgent")}
                ></Switch>
              </div>
            </div>
            <div className={classes.dataBlock}>
              <div className={classes.searchBtnWrapper}>
                <Button
                  color="primary"
                  onClick={handleFilter}
                  style={{ float: "left" }}
                >
                  <SearchIcon></SearchIcon>
                  {translation.dashboard_filternm_btntxt}
                </Button>
              </div>
              <div className={classes.grayBtnWrapper}>
                <Button
                  onClick={handleFilterClear}
                  style={{ float: "left", marginLeft: "5px" }}
                >
                  <ClearOutlinedIcon></ClearOutlinedIcon>
                  {translation.dashboard_filterclear_btntxt}
                </Button>
              </div>
            </div>
          </div>
        </Grid>
        <Grid
          container
          spacing={2}
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          className={classes.legendSection}
        >
          <div className={classes.StatusDetails}>
            <label><span className={classes.pendingState}></span>- PENDING</label>
          </div>
          <div className={classes.StatusDetails}>
            <label><span className={classes.initialState}></span>- INITIAL</label>
          </div>
          <div className={classes.StatusDetails}>
            <label><span className={classes.activeState}></span>- COMPLETED</label>
          </div>
          <div className={classes.StatusDetails}>
            <label><span className={classes.rejectedState}></span>- REJECTED</label>
          </div>
          <div className={classes.StatusDetails}>
            <label><span className={classes.cancelledState}></span>- CANCELLED</label>
          </div>
        </Grid>
      </Grid>
      {/* Filter area END */}
      <div className={classes.tblOuterBG}>
        <TableContainer className={classes.tblContainer}>
          <Table size="small" stickyHeader aria-label="sticky table">
            <TableHead className={classes.tblHeader}>
              <TableRow>
                <TableCell>Request #</TableCell>
                <TableCell>Vendor Name</TableCell>
                <TableCell>Vendor SAP NO</TableCell>
                <TableCell>Request Type</TableCell>
                <TableCell>Company Code</TableCell>
                <TableCell>Purch ORG</TableCell>
                <TableCell>Modified Date</TableCell>
                <TableCell>Approval Point</TableCell>
                <TableCell>Approvers</TableCell>
                <TableCell align="center" style={{ width: "165px" }}>
                  Action
                </TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className={classes.tblBody}>
              {vendorListItems &&
                vendorListItems.map((row, i) => {
                  return (
                    <TableRow key={row.requestId}>
                      <TableCell className= {getStatusCls(row.requestStatusId)}>{row.requestNo}</TableCell>
                      <TableCell>{row.vendorName}</TableCell>
                      <TableCell>{row.sapVendorNo}</TableCell>
                      <TableCell>{row.requestType}</TableCell>
                      <TableCell>{row.companyCode} </TableCell>
                      <Tooltip title={getDisplayPO(row)}>
                        <TableCell>{getDisplayPO(row)}</TableCell>
                      </Tooltip>

                      <TableCell>
                        {Util.getDisplayDateString(row.modifiedDate)}
                      </TableCell>
                      <TableCell>{row.approvalPoint}</TableCell>
                      <LightTooltip title={row.approverNames.join(", ")}>
                      <TableCell 
                       className={classes.descriptionCell}>
                        {row.approverNames.join(", ")}
                      </TableCell>
                      </LightTooltip>                   
                      <TableCell align="left">
                        {row.requestStatusId === RequestStatus.Pending &&
                          ApprovalPointUtil.isRequestApprovable(
                            row.companyCode,
                            row.currentApprovalPointIds,
                            row.approverNames
                          ) &&
                          !ApprovalPointUtil.isCallOverVerification(
                            row.currentApprovalPointIds[0],
                            row.requestStatusId
                          ) && (
                            // hidden={!ApprovalPointUtil.isVendorAprovalEnable(row.currentApprovalPointId,row.requestStatusId)}
                            <div>
                              <div className={classes.approveBtn}>
                                <button onClick={(e) => onApproveClick(row)}>
                                  <CheckCircleOutlineOutlinedIcon></CheckCircleOutlineOutlinedIcon>
                                  <span className={classes.approveBtnTxt}>
                                    Approve
                                  </span>
                                </button>
                              </div>
                              <div className={classes.rejectBtn}>
                                <button onClick={(e) => onRejectClick(row)}>
                                  <BlockOutlinedIcon></BlockOutlinedIcon>
                                  <span className={classes.rejectBtnTxt}>
                                    Reject
                                  </span>
                                </button>
                              </div>
                            </div>
                          )}
                        {/* hidden={!ApprovalPointUtil.isCallOverVerification(row.currentApprovalPointId,row.requestStatusId)} */}
                        {row.requestStatusId === RequestStatus.Pending &&
                          ApprovalPointUtil.isCallOverVerification(
                            row.currentApprovalPointIds[0],
                            row.requestStatusId
                          ) &&
                          ApprovalPointUtil.isUserPermitedApprovalPoint(
                            row.companyCode,
                            row.currentApprovalPointIds
                          ) && (
                            <div>
                              <div className={classes.clltoMobile}>
                                <button
                                  onClick={(e) => navigatetoCallOver(row)}
                                >
                                  <PhoneOutlinedIcon></PhoneOutlinedIcon>
                                  <span className={classes.approveBtnTxt}>
                                    {row.contactNumber1} {row.contactNumber2}
                                  </span>
                                </button>
                              </div>
                            </div>
                          )}
                        {/* hidden={!ApprovalPointUtil.isInitialVendorDetailMode(row.currentApprovalPointId,row.requestStatusId)} */}
                        {row.requestStatusId === RequestStatus.Initial &&
                        !ApprovalPointUtil.isOnlyObserver(row.companyCode) &&
                        (
                          <div>
                            {/* <div className={classes.vendorDetailLink}>
                              Vendor Detail
                            </div> */}
                            <div className={classes.cancelBtn}>
                              <button onClick={(e) => handleCancelRequest(row)}>
                                <CancelOutlinedIcon></CancelOutlinedIcon>
                                <span className={classes.cancelBtnTxt}>
                                  {translation.dashboard_list_cancelbtntxt}
                                </span>
                              </button>
                            </div>
                          </div>
                        )}
                      </TableCell>
                      <TableCell align="right">
                        <div className={classes.ArrowGo}>
                          <button onClick={(e) => onNavigateArrowClick(row)}>
                            <ArrowForwardIosIcon></ArrowForwardIosIcon>
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={filterParams.pageNo - 1}
          onPageChange={handleChangePage}
        ></TablePagination>
      </div>
      <ApproveDialog
        dataToApprove={dataToApprove!}
        setDataToApprove={setDataToApprove}
        open={openApprove}
        title={translation.dashboard_approve_title}
        message={translation.dashboard_approve_message}
        btnOnetext={translation.dashboard_approve_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onApproveConfirm={onAproveRequestConfirm}
        onApproveCancel={onAproveRequestCancel}
        handleClose={onApproveClose}
      ></ApproveDialog>
      <RejectDialog
        dataToReject={dataToApprove!}
        open={openReject}
        title={translation.dashboard_reject_title}
        message={translation.dashboard_reject_message}
        btnOnetext={translation.dashboard_reject_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onRejectConfirm={onRejectRequestConfirm}
        onRejectCancel={onRejectRequestCancel}
        handleClose={onRejectClose}
      ></RejectDialog>
    </div>
  );
}
